import fp from "lodash/fp";

import {
	float6Normalizer,
	minLength10,
	trimMidSentenceNormalizer,
	trimNormalizer,
} from "validators";
import {
	currencySixSigns,
	floatToSixValidation,
	maxLength10,
	maxLength7,
	maxValue100,
	minLength7,
	normalizeAll,
	onlyMaxDigits10,
	onlyMaxDigits7,
	onlyPercentToSixFloat,
	required,
	validateWhenAmexESA,
} from "validators/validation";

import { rangeValidator } from "./rangeValidator";

const feeNormalizer = value => float6Normalizer(value || 0);

const validators = isRequired => ({
	authorizationFee: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	salesTransactionFee: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	avs: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	aru: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	batchSettlement: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	additionalFeeOtherItemFee: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	chargebackFee: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	riseFreeTransFee: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	voiceAuth: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	voiceAVS: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	otherVolume: {
		validators: [
			rangeValidator(isRequired),
			maxValue100,
			floatToSixValidation,
		],
		normalize: onlyPercentToSixFloat,
		normalizeOnBlur: feeNormalizer,
	},
	returnTransactionFee: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	retrievalFee: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	applicationFee: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	annualFee: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	earlyTerminationFee: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	monthAnnualFeeBilled: {
		validators: fp.compact([isRequired && required]),
	},
	gatewayPerAuth: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	gatewayAdjustmentsFee: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	gatewayDepositFee: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	ebtAccountNumber: {
		validators: [minLength7, maxLength7],
		normalize: normalizeAll([onlyMaxDigits7, trimMidSentenceNormalizer]),
		normalizeOnBlur: trimNormalizer,
	},
	ebtCashPerItemFee: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	ebtFoodPerItemFee: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	pciComplianceFee: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	pciNonComplianceFee: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	tinInvalidFee: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	achRejectFee: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	inactivityFee: {},
	customerServiceFee: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	regulatoryProductFee: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	wirelessFee: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	equipmentFee: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	onlineReportingFee: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	softwareFee: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	statementFee: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	riseFreeProgramFee: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	monthlyMinimumFee: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	monthlyAccessFee: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	otherVolumeFee: {
		validators: [
			rangeValidator(isRequired),
			maxValue100,
			floatToSixValidation,
		],
		normalize: onlyPercentToSixFloat,
		normalizeOnBlur: feeNormalizer,
	},
	percentage: {
		validators: [maxValue100, floatToSixValidation],
		normalize: onlyPercentToSixFloat,
		normalizeOnBlur: feeNormalizer,
	},
	authorizationFeeOtherItemFee: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	voyagerQual: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	voyagerOtherItemRate: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	wexQual: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	wexOtherItemRate: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	amexESANumber: {
		validators: isRequired
			? [validateWhenAmexESA, minLength10, maxLength10]
			: [minLength10, maxLength10],
		normalize: onlyMaxDigits10,
	},
	amexOtherItemFee: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	amexOtherVolumeFee: {
		validators: [
			rangeValidator(isRequired),
			maxValue100,
			floatToSixValidation,
		],
		normalize: onlyPercentToSixFloat,
		normalizeOnBlur: feeNormalizer,
	},
	achFeePercent: {
		validators: [
			rangeValidator(isRequired),
			maxValue100,
			floatToSixValidation,
		],
		normalize: onlyPercentToSixFloat,
		normalizeOnBlur: feeNormalizer,
	},
	achFeeCurrency: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
	ariseFeeCurrency: {
		validators: [rangeValidator(isRequired), floatToSixValidation],
		normalize: currencySixSigns,
		normalizeOnBlur: feeNormalizer,
	},
});

export default validators;
